<template>
  <div>
    <div class="schedule-header">
      <span class="title">{{ $t('notificationSchedule') }}</span>
    </div>
    <SpinnerLoading v-if="isLoading" color="blue" class="schedule-spinner" />
    <div v-else class="schedule-list">
      <div class="entries">
        <div
          v-for="(item, index) in schedules"
          :key="index"
          class="entry"
        >
          <div class="info">
            <div class="time">
              {{ $t('fromSchedule') }} {{ item.from }}   {{ $t('toSchedule') }}  {{ item.to }}
            </div>
            <div class="days">
              {{ formatDays(item.days) }}
            </div>
          </div>
          <div class="actions">
            <button @click="editSchedule(index)">
              <svg class="icon">
                <use xlink:href="/img/symbol-defs-v2.svg#icon-pencil-2" />
              </svg>
            </button>
            <button @click="deleteSchedule(item.scheduleId)">
              <svg class="icon">
                <use xlink:href="#icon-trash" />
              </svg>
            </button>
          </div>
        </div>
        <div class="add-btn" @click="createSchedule">
          <img src="@/assets/img/icons/icon-add.svg" class="icon-add-schedule">
          <span>{{ $t('addSchedule') }} </span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import ScheduleAnalytics from "@/components/pacs/analytics/schedule/ScheduleAnalytics.vue";
import {ACTION_DELETE_SCHEDULE, ACTION_LOAD_SCHEDULES_LIST, DAYS_OF_WEEK} from "@/store/analytics/schedules/index.js";
import {createEntityMixin} from "@/components/pacs/mixins.js";
/**
 *  Компонент отображения списка расписаний
 *
 **/

export default {
  name: 'ScheduleList',
  mixins: [createEntityMixin],
  components: {
  },
  props: {
    analyticType: {
      type: String,
    },
    cameraNumber: {
      type: String,
    },
  },
  data() {
    return {
      schedules: [],
      scheduleId: '',
      isLoading: false,
    };
  },
  created() {
    this.loadSchedules();
  },
  methods: {
    /**
     *  Метод для загрузки списка расписаний
     *
     **/
    async loadSchedules() {
      this.isLoading = true;
      try {
        const response = await this.$store.dispatch(
          `analytics/schedules/${ACTION_LOAD_SCHEDULES_LIST}`,
          [this.cameraNumber, this.analyticType]
        );
        this.schedules = response.map(schedule => {
          const baseSetting = schedule.settings.find(s => s.is_active) || schedule.settings[0];
          const activeDays = schedule.settings
            .filter(s => s.is_active)
            .map(s => DAYS_OF_WEEK.find(d => d.value === s.day_of_week)?.label)
            .filter(Boolean);
          return {
            from: baseSetting.start_time.slice(0, 5),
            to: baseSetting.end_time.slice(0, 5),
            days: activeDays,
            scheduleId: schedule.schedule_id,
            settings: schedule.settings
          };
        });
      } finally {
        this.isLoading = false;
      }
    },
    /**
     *  Метод для удаления экземпляра расписания
     *
     **/
    async deleteSchedule(scheduleId) {
      this.$camsdals.confirm(this.$t('confirmDeleteSchedule'), async () => {
        this.isLoading = true;
        try {
          await this.$store.dispatch(`analytics/schedules/${ACTION_DELETE_SCHEDULE}`, [scheduleId]);
        } finally {
          this.isLoading = false;
          await   this.loadSchedules();
        }
      });
    },
    /**
     *  Открытие формы для создания расписания
     *
     **/
    createSchedule() {
      this.$camsdals.open(
        ScheduleAnalytics,
        {
          analyticType: this.analyticType,
          cameraNumber: this.cameraNumber,
        },
        {dialogTitle: this.$t('createSchedule')},
        {
          closeOnBackdrop: true,
          size: "vuedal-auto-width",
          name: "js-click-outside",
          onClose: (result) => {
            if (result) {
              this.loadSchedules();
            }
          }
        }
      );
    },
    /**
     *  Открытие формы для редактирования расписания
     *
     **/
    editSchedule(index) {
      const item = this.schedules[index];
      this.$camsdals.open(
        ScheduleAnalytics,
        {
          scheduleId: item.scheduleId,
          analyticType: this.analyticType,
          cameraNumber: this.cameraNumber,
          settings: item.settings,
          from: item.from,
          to: item.to,
          days: item.days,
        },
        {dialogTitle: this.$t('editSchedule')},
        {
          closeOnBackdrop: true,
          size: "vuedal-auto-width",
          name: "js-click-outside",
          onClose:   (result) => {
            if (result) {
              this.loadSchedules();
            }
          }
        }
      );
    },
    formatDays(days) {
      return days.join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
@use "./style.scss";
</style>
